<template>

    <div class="container">
      <header-com />
      <header class="header">
        <div class="center">
          <i class="back"></i>
          <div class="status">
        
          </div>
        </div>
      </header>
      <div class="abs-address">
        <div class="address-com ">
          <div class='img_cont'>
            
            <img :src='serviceDetail'>
          </div>
          <div class='dero_content'>
            <h1 class='name'>{{detail.name}}</h1>
            <div>
              <span class='category_type'>{{detail.categoryName}}</span>
              <span>¥{{detail.cardprice}}</span>
            </div>
          </div>
        </div>  
      </div>
      <div class="goods-info" >
        <div class="title f32">
          <div class="block"></div>
          <span>结算信息</span>
        </div>
        
        <ul style='color:#666666' class='ul_detail'>
          <li class="f28">付款时间：{{detail.createTime}}</li>
          <li class="f28">服务数量：{{detail.quantity}}</li>
          <li class="f28">订单金额：¥{{detail.priceText}}</li>
          <li class="f28" v-if='detail.discountPrice'>促销优惠：¥{{detail.discountPrice}}</li>
          <li class="f28">实付金额：¥{{detail.curingServiceRealPrice}}</li>
        </ul>

      </div>
    
    </div>
</template>

<script>

  export default {
    name: 'purchaseDetail',
    components : {

    },
    data () {
      return {
        detail : {},
        serviceDetail : '',
      }
    },
    computed: {

    },
    created () {
      this.detail = JSON.parse(this.$route.query.detail);
      let name = this.detail.categoryName;
      if(!name){
        this.serviceDetail =  require('../../../../public/images/my/serviceDetail0.png');
        return;
      }
      if(name.match('包') && name.match('包').length>0){
        this.serviceDetail =  require('../../../../public/images/my/serviceDetail0.png');
      }else if( name.match('鞋') && name.match('鞋').length>0){
        this.serviceDetail =  require('../../../../public/images/my/serviceDetail1.png');
      }else if(name.match('饰') && name.match('饰').length>0){
        this.serviceDetail =  require('../../../../public/images/my/serviceDetail2.png');
      }else if(name.match('衣') && name.match('衣').length>0){
        this.serviceDetail =  require('../../../../public/images/my/serviceDetail3.png');
      }else{
        this.serviceDetail =  require('../../../../public/images/my/serviceDetail0.png');
      }

    },
    mounted () {

    },
    methods: {     
      

    }
  }
</script>

<style scoped lang="scss">
  .title_icon{
    width: 40px;
    margin-right: 20px;
    position: relative;
    top:3px;
  }
  .markShdow{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    text-align: center;
    background: rgba(0,0,0,.8);
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .markShdow div {
      width: 100%;
      position: relative;
      margin-top:200px;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column-reverse;
      flex-direction: column-reverse;
  }
  .markShdow div>img{
      width: 100%;
  }
  .markShdow div .qrcode-wrap {
      position: absolute;
      bottom: 15px;
      width: 280px;
      height: 280px;
      background: red;
      left: 50%;
      margin-left:-140px;
  }
  .container{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 108px;
    .header{
      width: 100%;
      height: 200px;
      background: url('/images/order/order-header-bg.png') no-repeat center;
      .center{
        padding: 30px 30px 0 30px;
        display: flex;
        justify-content: space-between;
        .back{
          width: 60px;
          height: 60px;
          // background: url('/images/public/back.png') no-repeat center;
          background-size: 60px;
        }
        .status{
          width: 170px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          text-align: right;
          .status-text{
            color: #fff;
            text-align: right;
          }
        }
      }
    }
    .abs-address{
      position: absolute;
      top: 124px;
    }
    .goods-info{
      margin-top: 166px;
      ul{
        margin: 30px 0;
        li{
          margin-bottom: 20px;
          padding-left: 20px;
          &:last-child{
            margin: 0;
          }
        }
      }
    }
    .connect-kf{
      width: 100%;
      height: 94px;
      border-top: 2px solid #EEEEEE;
      display: flex;
      align-items: center;
      justify-content: center;
      i{
        width: 32px;
        height: 32px;
        margin-right: 20px;
        background: url("/images/order/kefu-avar.png") no-repeat center;
        background-size: 32px;
      }
    }
    .order-info{
      padding: 30px 0;
      color: #666666;
      ul{
        padding-left: 18px;
        margin-top: 34px;
        li{
          line-height: 40px;
          margin-bottom: 10px;
          max-width: 512px;
          position: relative;
          .copy{
            right: -152px;
            position: absolute;
          }
        }
      }
    }
    .remark{
      border-top: 2px solid #EEEEEE;
      width: 100%;
      padding: 30px 0;
      div{
        padding: 0 50px;
        line-height: 40px;
      }
    }
    .price-info{
      width: 100%;
      ul{
        padding: 30px;
        border-bottom: 2px solid #eee;
        li{
          display: flex;
          justify-content: space-between;
          line-height: 44px;
          margin-bottom: 20px;
          &:last-child{
            margin: 0;
          }
        }
      }
      div{
        padding: 0 30px;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        height: 142px;
        line-height: 142px;
        font-weight: 500;
        span{
          &:last-child{
            margin-right: 20px;
          }
        }
      }
    }
    .shadow{
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      height: 108px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      padding-top: 0;
      button{
        margin-right: 20px;
        &:first-child{
            margin-right: 0px;
        }
      }
    }
  }
  .van-popup--bottom{
    width: 101%;
  }
  .containers{
    height: 740px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    ul li{
      width: 100%;
      height: 40px;
      
      margin-bottom: 60px;
      display: flex;
      align-items: center;
      span{
        margin-top:2px; 
      }
      &>div{
        margin-right: 20px;
      }
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
   .defult_img{
    width: 64px;
    position: relative;
    top:4px;
    margin-left: 10px;
  }


  .address-com{
    width: 690px;
    height: 192px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
    border-radius:6px;
    display: flex;
    padding-right: 16px;
    .img_cont{
      display: flex;
      align-items: center;
      width: 200px;
      img{
        margin-left: 16px;
        width: 160px;
        height: 160px;
      }
    }
    .dero_content{
      width: 490px;
      margin-left: 15px;
      .name{
        color:#333;
        font-size:32px;
        font-weight: 500; 
        line-height: 60px;
        margin-top: 16px;
        overflow: hidden;    
        text-overflow: ellipsis;      //超出部分以省略号显示
        white-space: nowrap;
      }
      div{
        margin-top:60px;
        display: flex;
        justify-content: space-between;
        font-size: 36px;
        font-weight: 500;
      }
      .category_type{
        font-size: 24px;
        font-weight: normal;
        position: relative;
        top:10px;
      }
    }
    
  }

  .title{
    height: 44px;
    width: 690px;
    display: flex;
    align-items: center;
    font-weight:500;
    .block{
      width:8px;
      height:28px;
      background:rgba(122,223,223,1);
      margin-right: 10px;
    }
  }
  .ul_detail{
    li{
      margin-top: 30px!important;
      font-size: 28px;
      margin-bottom: 30px!important;
    }
  }

</style>
